import { MantineThemeOverride } from "@mantine/core";

export const colors: MantineThemeOverride["colors"] = {
  black: ["#000000"],
  midnightBlue: ["#182d48"],
  dusk: ["#23567c"],
  golden: ["#e9b264"],
  white: ["#ffffffff"],
  actionIcon: ["#e6ebf4", "#d9e5f5", "#f1e6e6", "#ffe0e0"],
  grayIce: [
    "#b0b6bd",
    "#a1a3a5",
    "#f4f5f6",
    "#f7f8f9",
    "#e6ecf7",
    "#d2def0",
    "#f6f8fc",
    "#e4e4e4",
    "#d0d0d0",
    "#616161",
  ],
  error: ["#7a4a28"],
  greenIce: [
    "#E3E6E1",
    "#A4B69B",
    "#6FA456",
    "#489623",
    "#7DDE4F",
    "#4CA024",
    "#191B17",
    "#101110",
    "#0B0B0B",
    "#070707",
  ],
  contractsTable: [
    "#ABD297",
    "#FCE77C",
    "#FBB835",
    "#FF8F3D",
    "#fa7575",
    "#FFFFFF",
    "#FFFFFF",
    "#FFFFFF",
    "#FFFFFF",
    "#FFFFFF",
  ],
  green: ["#ABD297"],
  red: ["#fa7f7f"],
  yellow: ["#FCE77C"],
  grey: ["#B0B6BD"],
};
